import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useRef } from "react";

import { $gitHistory } from "../../internal/git";

/**
 * Hook to access git repository history
 * @param documentId - The document ID
 * @returns The git commit history
 */
export const useGitHistory = (documentId: string | undefined) => {
	const historyAtom = $gitHistory(documentId);
	const historyLoadable = useAtomValue(loadable(historyAtom));
	const refresh = useSetAtom(historyAtom);

	// Keep track of the last successful data to avoid flickering while loading
	const lastDataRef = useRef(
		historyLoadable.state === "hasData" ? historyLoadable.data : undefined
	);

	// Update the ref when we have new data
	if (historyLoadable.state === "hasData") {
		lastDataRef.current = historyLoadable.data;
	}

	return {
		// Return last successful data while loading (stale-while-revalidate)
		history: historyLoadable.state === "hasData" ? historyLoadable.data : lastDataRef.current,
		refresh,
		isLoading: historyLoadable.state === "loading",
		isError: historyLoadable.state === "hasError",
	};
};
